import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  Output,
  PLATFORM_ID,
  Renderer2,
  ViewEncapsulation
} from '@angular/core';
import { KAZAPLAN_CONST } from '../../../utils/const/kazaplan';

declare var require: any;

@Component({
  selector: 'app-kazaplan-360-viewer',
  templateUrl: './kazaplan-360-viewer.component.html',
  styleUrls: ['./kazaplan-360-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Kazaplan360ViewerComponent implements OnChanges {
  @Input() imageUrl: string = null;

  @Input() htmlId: string = null;
  @Input() viewportWidth = '100vw';
  @Input() viewportHeight = '80vh' ;
  @Output() isReady: EventEmitter<boolean> = new EventEmitter();

  @HostBinding('class.kz-kaza-360--preview') hostClass = true;

  constructor(
      @Inject(PLATFORM_ID) private platformId: object,
      private renderer: Renderer2,
      private elem: ElementRef) {
  }

  ngOnChanges(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadScript();
    }
  }

  loadScript() {
    const resetId = this.elem.nativeElement.querySelectorAll(this.htmlId ? '#' + this.htmlId : '#kazaplan-360-viewer')[0];
    if (resetId !== null && resetId !== undefined) {
      this.renderer.setProperty(resetId, 'innerHTML', '');
    }
    const obsidianApp = require('obsidian-api/lib/integration');

    setTimeout(() => {
      const viewer = obsidianApp({
        htmlNode: this.htmlId ? '#' + this.htmlId : '#kazaplan-360-viewer',
        appUrl: KAZAPLAN_CONST.KAZAPLAN_360_URL,
        width: this.viewportWidth,
        height: this.viewportHeight
      });

      window[`app`] = viewer;
      (window as any).global = window;

      viewer.on('ready', () => {
        viewer.openFromUrl(this.imageUrl);
        this.isReady.emit(true);
      });
    }, 500);
  }
}
